import styled from 'styled-components';

export const StyledContent = styled.div`
  position: relative;

  input {
    padding-right: 30px;

    &:active,
    &:focus {
      padding-right: 30px;
    }
  }
`;

export const StyledEyeWrapper = styled.div`
  position: absolute;
  right: 11px;
  top: 36px;
  cursor: pointer;
`;
